import StatsCard from "./stats-card";

export default StatsCard;
